import { fetchBasicJsonPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    getBranches: () => {
        return new Promise((resolve, reject) => {
            resolve({
                data: [],
                total: 0
            });
        });
    },
    getData: (page, itemsPerPage, filter, settings) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        parameters.nosology_kod = filter.nosology_kod || null;
        parameters.date_till = filter.date_till || null;
        parameters.is_open = filter.is_open || null;
        parameters.person_code =
            filter.person_code && /^\d+$/.test(filter.person_code)
                ? +filter.person_code
                : null;
        parameters.kods_for_shift = filter.kods_for_shift || null;
        return fetchBasicJsonPostJson('/Salary/GetDataTableData', {
            ...settings,
            data: parameters
        });
    },
    add: item => {
        return fetchBasicJsonPost('/Salary/Add', {
            data: item
        });
    },
    edit: item => {
        return fetchBasicJsonPost('/Salary/Edit', {
            data: item
        });
    },
    delete: item => {
        return fetchBasicJsonPost('/Salary/Delete', {
            data: item
        });
    }
};
